import { useState } from "react";
import { X } from "lucide-react";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import Seo from "../../components/Seo";
import rucola from "../../assets/images/gallery/pizzarucola-e-pizzasalamino.jpeg";
import locale from "../../assets/images/gallery/pizzeria-interno.jpeg";
import bianca from "../../assets/images/gallery/bianca.jpeg";
import comanda from "../../assets/images/gallery/pizze-comanda.jpeg";
import rosso from "../../assets/images/gallery/rosso-relativo.jpeg";
import interno1 from "../../assets/images/pizzeria-interno1.jpeg";
import interno2 from "../../assets/images/pizzeria-interno2.jpeg";
import interno3 from "../../assets/images/pizzeria-interno3.jpeg";
import pizza from "../../assets/images/pizza-dx.jpeg";
import "./GalleryPage.css";

const photos = [
    { src: rucola, alt: "Pizza con rucola e pizza al salamino Busca Vida" },
    { src: locale, alt: "Interno di Busca Vida Pizzeria a Cecina" },
    { src: bianca, alt: "Pizza bianca preparata da Busca Vida" },
    { src: comanda, alt: "Pizze appena preparate da Busca Vida" },
    { src: rosso, alt: "Dettaglio del locale Busca Vida" },
    { src: interno1, alt: "Sala della pizzeria Busca Vida a Cecina" },
    { src: interno2, alt: "Ambiente interno della pizzeria Busca Vida" },
    { src: interno3, alt: "Tavoli del locale Busca Vida a Cecina" },
    { src: pizza, alt: "Pizza Busca Vida servita a Cecina" },
];

export default function GalleryPage() {
    const [selectedPhoto, setSelectedPhoto] = useState(null);

    return (
        <>
            <Seo
                title="Foto della pizzeria | Busca Vida Cecina"
                description="Guarda le foto di Busca Vida Pizzeria a Cecina: il locale, le pizze e i piatti preparati dalla nostra cucina."
                path="/gallery"
            />
            <Navbar />
            <main className="gallery-page">
                <header className="gallery-page-header container">
                    <p>Dentro Busca Vida</p>
                    <h1>Gallery</h1>
                    <span>Il locale, le pizze e i momenti da condividere a tavola.</span>
                </header>

                <section className="gallery-page-grid container" aria-label="Foto di Busca Vida">
                    {photos.map((photo, index) => (
                        <button
                            type="button"
                            key={photo.src}
                            className={`gallery-page-photo photo-${index + 1}`}
                            onClick={() => setSelectedPhoto(photo)}
                            aria-label={`Ingrandisci: ${photo.alt}`}
                        >
                            <img src={photo.src} alt={photo.alt} loading={index > 2 ? "lazy" : "eager"} />
                        </button>
                    ))}
                </section>

                <section className="gallery-page-cta">
                    <h2>Vieni a trovarci</h2>
                    <p>Viale della Repubblica 29, Cecina</p>
                    <a href="tel:+393513478565">Prenota un tavolo</a>
                </section>
            </main>
            <Footer />

            {selectedPhoto && (
                <div className="gallery-lightbox" role="dialog" aria-modal="true" aria-label={selectedPhoto.alt}>
                    <button type="button" onClick={() => setSelectedPhoto(null)} aria-label="Chiudi foto">
                        <X size={26} />
                    </button>
                    <img src={selectedPhoto.src} alt={selectedPhoto.alt} />
                </div>
            )}
        </>
    );
}

